import React, { useEffect } from "react";

import { MaterialReactTable } from "material-react-table";
import { sharedTableProps } from "../shared/tableProps";
import "../util/tables.css";
import { useDataView } from "../../contexts/data.view.context";
import ShowLoadingBar from "../util/showLoadingBar";
import * as API from "../api/index";

const ErrorLogDetails = () => {
  const columns = [
    {
      accessorKey: "pkError",
      header: "pkError",
      id: "ID",
      size: 30,
      Cell: ({ row }) => {
        const { pkError } = row.original;
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a href="#" onClick={() => handleDownload(pkError)}>
            {pkError}
          </a>
        );
      },
    },
    /** 
    {
      accessorKey: "ErrorId",
      header: "ErrorId",
      id: "ErrorId",
      size: 50,
    },
    */
    {
      accessorKey: "ErrorTs",
      header: "ErrorTs",
      id: "ErrorTs",
      size: 40,
    },
    {
      accessorKey: "Entity",
      header: "Entity",
      id: "Entity",
      size: 50,
    },
    {
      accessorKey: "Source",
      header: "Source",
      id: "Source",
      size: 50,
    },
    {
      accessorKey: "ServiceName",
      header: "ServiceName",
      id: "ServiceName",
    },
    {
      accessorKey: "ServicePath",
      header: "ServicePath",
      id: "ServicePath",
    },

    {
      accessorKey: "ErrorCode",
      header: "ErrorCode",
      id: "ErrorCode",
      size: 50,
    },
    {
      accessorKey: "ErrorDesc",
      header: "ErrorDesc",
      id: "ErrorDesc",
      size: 50,
    },
  ];

  const { fetchErrorDetails, errorDetails } = useDataView();

  /** 
  useEffect(() => {
    (async () => {
      if (errorDetails.length === 0) await fetchErrorDetails();
    })();
    // eslint-disable-next-line
  }, []);
  */

  const fetchData = async () => {
    if (errorDetails.length === 0) await fetchErrorDetails();
  };

  useEffect(() => {
    fetchData(); // Fetch data initially
    // set auto refresh interval to 5 mins = 300 seconds
    const intervalId = setInterval(() => {
      fetchErrorDetails();
    }, 300000);

    return () => clearInterval(intervalId); // Clean up the interval on component unmount
    // eslint-disable-next-line
  }, []);

  let loading = false;
  if (errorDetails.length === 0) {
    loading = true;
  }

  if (Boolean(loading)) {
    return <ShowLoadingBar title="Error Log Details" loading={loading} />;
  }

  const handleDownload = async (pkError) => {
    try {
      const blob = await API.downloadErrorEventXml(pkError);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${pkError}.xml`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
      alert("File download failed");
    }
  };

  return (
    <div className="relative">

      {errorDetails.length > 0 && (
        <MaterialReactTable
          {...sharedTableProps}
          columns={columns}
          data={errorDetails.map((errorDetails) => {
            return {
              pkError: errorDetails.pkError,
              ErrorId: errorDetails.ErrorId,
              ErrorTs: errorDetails.ErrorTs,
              Entity: errorDetails.Entity,
              EnvironName: errorDetails.EnvironName,
              ServiceName: errorDetails.ServiceName,
              ServicePath: errorDetails.ServicePath,
              Source: errorDetails.Source,
              ErrorCode: errorDetails.ErrorCode,
              ErrorDesc: errorDetails.ErrorDesc,
            };
          })}
          initialState={{
            density: "compact",
            pagination: { pageSize: 20 },
          }}
          autoResetPageIndex={false}
        />
      )}
    </div>
  );
};

export default ErrorLogDetails;
